import React, { useState, useEffect } from 'react';

const InstallPWA = () => {
    const [showInstallButton, setShowInstallButton] = useState(true);
    const [promptInstall, setPromptInstall] = useState(null);
    const [isInstalled, setIsInstalled] = useState(false);

    useEffect(() => {
        // Vérifier si l'app est déjà installée
        const checkInstalled = () => {
            if (window.matchMedia('(display-mode: standalone)').matches) {
                setIsInstalled(true);
                setShowInstallButton(false);
            }
        };

        checkInstalled();

        // Gestion de l'événement beforeinstallprompt
        const handler = (e) => {
            e.preventDefault();
            setPromptInstall(e);
        };

        window.addEventListener('beforeinstallprompt', handler);

        // Vérifier si on est sur un appareil Apple
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        const isSafari = navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome');

        // Toujours montrer le bouton pour iOS/Safari
        if (isIOS || isSafari) {
            setShowInstallButton(true);
        }

        return () => {
            window.removeEventListener('beforeinstallprompt', handler);
        };
    }, []);

    const handleInstallClick = async () => {
        // Pour iOS/Safari
        if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
            alert('Pour installer l\'application sur iOS:\n1. Appuyez sur le bouton "Partager"\n2. Faites défiler et appuyez sur "Sur l\'écran d\'accueil"');
            return;
        }

        // Pour les autres navigateurs
        if (promptInstall) {
            try {
                promptInstall.prompt();
                const { outcome } = await promptInstall.userChoice;
                if (outcome === 'accepted') {
                    setIsInstalled(true);
                    setShowInstallButton(false);
                }
            } catch (error) {
                console.error('Erreur lors de l\'installation:', error);
            }
        }
    };

    // Ne pas afficher si déjà installé ou si le bouton ne doit pas être montré
    if (isInstalled || !showInstallButton) {
        return null;
    }

    return (
        <button
            onClick={handleInstallClick}
            className="fixed bottom-20 md:bottom-8 right-4 md:right-8 bg-black text-white px-4 py-2 rounded-lg shadow-lg flex items-center space-x-2 hover:bg-gray-800 transition-colors z-[9999]"
            style={{ zIndex: 9999 }}
        >
            <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                />
            </svg>
            <span>Installer l'application</span>
        </button>
    );
};

export default InstallPWA;